import { useIsMobile } from "../../utils/deviceDetection";
import SupervisorDashboard from "./SupervisorDashboard";
import SupervisorMobileLanding from "./supervisorMobileLanding";

const SupervisorLanding = () => {
  const isMobile = useIsMobile();

  return isMobile ? <SupervisorMobileLanding /> : <SupervisorDashboard />;
};

export default SupervisorLanding;
